import React, { useEffect } from 'react';
import SignupContentWrapper from '../components/SignupContentWrapper';
import { useRouteConfig } from '../utils/useRouteConfig';
import { PATH } from '../../../routes';
import ConfirmOrganizationInfo from '../components/confirmOrganizationInfo/ConfirmOrganizationInfo';
import { VIEW_EVENT, VIEW_ORG_CONFIRMATION_MODAL } from 'utils/clevertapEvents';
import { pushEvent } from 'utils/clevertapUtils';
import { SEARCH_EXPERIMENT, SEARCH_UI_EXPERIMENT } from 'utils/clevertapVariantFlags';

const STEP_INFO = 1;

export const ConfirmOrganization: React.FC = () => {
    const { previous } = useRouteConfig(PATH.SIGNUP.STEPS.CONFIRM_ORGANIZATION);

    useEffect(() => {
        pushEvent(VIEW_ORG_CONFIRMATION_MODAL, {
            [SEARCH_EXPERIMENT]: 'on',
            [SEARCH_UI_EXPERIMENT]: 'on',
        });
        pushEvent(VIEW_EVENT, {
            name: 'SignupConfirmOrg'
        });
    }, []);

    return (
        <SignupContentWrapper
            showCloseButton={true}
            heading=""
            stepInfo={STEP_INFO}
            backUrl={previous}
            maxWidth={700}
        >
            <ConfirmOrganizationInfo />
        </SignupContentWrapper>
    );
};
